import { makeAutoObservable } from "mobx"

export class ServerAPImodel{
    constructor(){
        this.baseAPI = localStorage.getItem("baseAPI") ? 
            (localStorage.getItem("auth_token") ? localStorage.getItem("baseAPI") : this.setInStorage("https://spotlogicunit4.pp.ua/api/v1/")) :
            this.setInStorage("https://spotlogicunit4.pp.ua/api/v1/")
        this.baseAPIAdmin = this.baseAPI + "admin/"
        this.baseAPILogin = this.baseAPI + "sessions/"
        this.baseAPIManagerInfo = this.baseAPI + "users/my_profile"
        this.socketUrl = ""
        this.socketUrl = ""
        makeAutoObservable(this)
    }
    setBaseAPI = serverInd =>{
        if(serverInd === 1){  
            this.baseAPI = "https://spotlogicunit4.pp.ua/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://spotlogicunit4.pp.ua/api/v1/admin/"
            this.baseAPILogin = "https://spotlogicunit4.pp.ua/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://spotlogicunit4.pp.ua/api/v1/users/my_profile"
        }else if(serverInd === 2){
            this.baseAPI = "https://qa.spotlogic.site/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://qa.spotlogic.site/api/v1/admin/"
            this.baseAPILogin = "https://qa.spotlogic.site/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://qa.spotlogic.site/api/v1/users/my_profile"
            this.socketUrl = "wss://qa.spotlogic.site/cable"
        }else if(serverInd === 3){
            this.baseAPI = "https://xerox.pp.ua/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://xerox.pp.ua/api/v1/admin/"
            this.baseAPILogin = "https://xerox.pp.ua/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://xerox.pp.ua/api/v1/users/my_profile"
            this.socketUrl = "wss://xerox.pp.ua/cable"
        }
        else if(serverInd === 4){
            this.baseAPI = "https://spotlogic-mlogica.pp.ua/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://spotlogic-mlogica.pp.ua/api/v1/admin/"
            this.baseAPILogin = "https://spotlogic-mlogica.pp.ua/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://spotlogic-mlogica.pp.ua/api/v1/users/my_profile"
            this.socketUrl = "wss://spotlogic-mlogica.pp.ua/cable"
        }
        else if(serverInd === 5){
            this.baseAPI = "https://netappspotlogic.pp.ua/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://netappspotlogic.pp.ua/api/v1/admin/"
            this.baseAPILogin = "https://netappspotlogic.pp.ua/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://netappspotlogic.pp.ua/api/v1/users/my_profile"
            this.socketUrl = "wss://netappspotlogic.pp.ua/cable"
        }
        else if(serverInd === 6){
            this.baseAPI = "https://hashicorp.spotlogic.site/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://hashicorp.spotlogic.site/api/v1/admin/"
            this.baseAPILogin = "https://hashicorp.spotlogic.site/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://hashicorp.spotlogic.site/api/v1/users/my_profile"
            this.socketUrl = "wss://hashicorp.spotlogic.site/cable"
        }
        else if(serverInd === 7){
            this.baseAPI = "https://solrenewables.spotlogic.site/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://solrenewables.spotlogic.site/api/v1/admin/"
            this.baseAPILogin = "https://solrenewables.spotlogic.site/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://solrenewables.spotlogic.site/api/v1/users/my_profile"
            this.socketUrl = "wss://solrenewables.spotlogic.site/cable"
        }
        else if(serverInd === 8){
            this.baseAPI = "https://scholarpath.spotlogic.site/api/v1/"
            localStorage.setItem("baseAPI", this.baseAPI)
            this.baseAPIAdmin = "https://scholarpath.spotlogic.site/api/v1/admin/"
            this.baseAPILogin = "https://scholarpath.spotlogic.site/api/v1/sessions/"
            this.baseAPIManagerInfo = "https://scholarpath.spotlogic.site/api/v1/users/my_profile"
            this.socketUrl = "wss://scholarpath.spotlogic.site/cable"
        }
        
    }
    setInStorage = api =>{
        localStorage.setItem("baseAPI", api)
        return api
    }
}

export const serverAPImodel = new ServerAPImodel